// Page JobOffer

import './index.scss';

export default class PageJoboffer {
  constructor(root) {
    this.root = root;
    this.update();
  }

  // Init

  initButton() {
    const button = this.root.querySelector('[data-popup-open="app-form-popup"]');
    if (button) {
      button.addEventListener('click', this.trackFormOpen.bind(this));

      const params = new URLSearchParams(window.location.search);
      const openform = (params).get('openform');
      if (openform) {
        button.click();
      }
    }
  }

  // Tracking

  trackPageOpen() {
    this.initButton();

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'Joboffer opened',
      'title': this.root.dataset.jobofferName,
      'location': this.root.dataset.jobofferLocation,
      'function': this.root.dataset.jobofferActivity,
    });

    //console.log(window.dataLayer);
  }

  trackFormOpen() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'Application form opened',
      'title': this.root.dataset.jobofferName,
      'location': this.root.dataset.jobofferLocation,
      'function': this.root.dataset.jobofferActivity,
    });

    //console.log(window.dataLayer);
  }

  trackFormSend() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'Application sent',
      'title': this.root.dataset.jobofferName,
      'location': this.root.dataset.jobofferLocation,
      'function': this.root.dataset.jobofferActivity,
    });

    //console.log(window.dataLayer);
  }

  // Update

  resize() { this.update(); }
  scroll() { this.update(); }

  update() {
    const w = window.innerWidth;

    if (w < window.breakpoint.sm) {
      this.updateMobile();
    }

    if (window.breakpoint.sm <= w && w < window.breakpoint.md_sh) {
      this.updateTablet();
    }

    if (window.breakpoint.md_sh <= w) {
      this.updateDesktop();
    }
  }

  updateMobile() {
    const bp = this.root.querySelector('.sidebar__button-placeholder');
    const bw = this.root.querySelector('.sidebar__button-wrapper');

    const y = window.scrollingY();
    const h = window.innerHeight;
    const bp_y = bp.offsetTop;
    const bw_h = bw.offsetHeight;

    const t = y + h - bw_h;

    if (t >= bp_y) {
      bw.classList.remove('fixed');
    } else {
      bw.classList.add('fixed');
    }

    if (t >= bp_y + 80) {
      bw.classList.remove('sized');
    } else {
      bw.classList.add('sized');
    }
  }

  updateTablet() {
    const sp = this.root.querySelector('.sidebar__share-placeholder');
    const sw = this.root.querySelector('.sidebar__share-wrapper');

    const y = window.scrollingY();
    const h = window.innerHeight;
    const sp_y = sp.offsetTop;
    const sw_h = sw.offsetHeight;

    const t = y + h - sw_h;

    if (t >= sp_y) {
      sw.classList.remove('fixed');
    } else {
      sw.classList.add('fixed');
    }

    if (t >= sp_y + 80) {
      sw.classList.remove('sized');
    } else {
      sw.classList.add('sized');
    }
  }

  updateDesktop() {
    const ip = this.root.querySelector('.sidebar__info-placeholder');
    const iw = this.root.querySelector('.sidebar__info-wrapper');

    const h_h = 60;
    const w_y = window.scrollingY();

    const ip_y = ip.offsetTop;
    const ip_h = ip.offsetHeight;
    const iw_h = iw.offsetHeight;

    const y = w_y - ip_y;
    const a = 0;
    const b = ip_h - iw_h;

    if (y <= a - h_h) {
      iw.classList.remove('fixed');
      iw.classList.remove('bottom');
    } else if (y > a - h_h && y <= b - h_h) {
      iw.classList.add('fixed');
      iw.classList.remove('bottom');
    } else if (y > b - h_h) {
      iw.classList.remove('fixed');
      iw.classList.add('bottom');
    }
  }
}
